export enum SummaryType {
  ABSOLUTE = "ABSOLUTE",
  RELATIVE = "RELATIVE",
  BENCHMARK = "BENCHMARK",
}

export default SummaryType;

export const summaryTypeOptionsLegacy = [
  {
    label: "Absolute",
    value: SummaryType.ABSOLUTE,
  },
  {
    label: "Relative",
    value: SummaryType.RELATIVE,
  },
];

export const summaryTypeOptions = [
  {
    label: "Account",
    value: SummaryType.ABSOLUTE,
  },
  {
    label: "Benchmark",
    value: SummaryType.BENCHMARK,
  },
  {
    label: "Relative",
    value: SummaryType.RELATIVE,
  },
];
export const summaryTypeOptionsWithoutRelative = summaryTypeOptions.filter(
  (o) => o.value !== SummaryType.RELATIVE
);
